import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-remaining-earnings',
  templateUrl: './remaining-earnings.component.html',
  styleUrls: ['./remaining-earnings.component.css']
})
export class RemainingEarningsComponent implements OnInit {

  @Input() RemainingEarnings: number;

  //@Output() filterProgramsEvent = new EventEmitter();
  //program_status = '';

  constructor() { }

  ngOnInit() {
  }

  //filterProgramListing(value) {
  //  this.program_status = value;
  //  //this.filterProgramsEvent.emit(this.program_status);
  //}
}



// WEBPACK FOOTER //
// ./src/app/components/remaining-earnings/remaining-earnings.component.ts